/** Staff panel URL helpers — shared across admin / instructor / partner / order-manager. */

export function isInstructorRole(role: string | undefined | null): boolean {
  return role === 'instructor' || role === 'mentor';
}

export function isAffiliateRole(role: string | undefined | null): boolean {
  return role === 'affiliate';
}

export function isOrderManagerRole(role: string | undefined | null): boolean {
  return role === 'order_manager';
}

export function staffPanelBase(role: string | undefined | null): string {
  if (isInstructorRole(role)) return '/instructor';
  if (isAffiliateRole(role)) return '/partner';
  if (isOrderManagerRole(role)) return '/order-manager';
  return '/admin';
}

/** e.g. staffPath('order_manager', 'book-orders') → '/order-manager/book-orders' */
export function staffPath(role: string | undefined | null, segment: string): string {
  const clean = segment.replace(/^\//, '');
  return `${staffPanelBase(role)}/${clean}`;
}

/** Default landing after login/signup by role. */
export function roleHomePath(role: string | undefined | null): string {
  if (role === 'student') return '/dashboard/overview';
  return staffPath(role, 'overview');
}

/**
 * Where to send the user after auth.
 * Staff always go to their panel. Students go to /dashboard/overview unless `from` is a
 * real deep link — never bounce back to `/` or auth pages.
 */
export function postLoginPath(role: string | undefined | null, from?: string | null): string {
  const home = roleHomePath(role);
  if (role !== 'student') return home;
  if (!from || !from.startsWith('/')) return home;
  if (
    from === '/' ||
    from.startsWith('/login') ||
    from.startsWith('/register') ||
    from.startsWith('/affiliate/register')
  ) {
    return home;
  }
  if (from === '/dashboard') return home;
  return from;
}
